import React, { useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';

import { onDoLogout } from '@/redux/auth';
import { AuthContext } from '@context/auth';

import IconMarginTrading from '@assets/Icon/MenuProfile/svg/IconMarginTrading';
import IconAjakTeman from '@assets/Icon/MenuProfile/svg/IconAjakTeman';
import IconBonus from '@assets/Icon/MenuProfile/svg/IconBonus';
import IconKalkulator from '@assets/Icon/MenuProfile/svg/IconKalkulator';
import IconBelajar from '@assets/Icon/MenuProfile/svg/IconBelajar';
import IconKamus from '@assets/Icon/MenuProfile/svg/IconKamus';
import IconBantuanAjaib from '@assets/Icon/MenuProfile/svg/IconBantuanAjaib';
import IconKeluar from '@assets/Icon/MenuProfile/svg/IconKeluar';
import IconPnL from '@/assets/Icon/MenuProfile/svg/IconPnL';
import IconKeamananAkun from '@/assets/Icon/MenuProfile/svg/IconKeamananAkun';

import { WEB_VERSION } from '@config/constanta';
import useEventTracker from './tracker';
import {
  styLabelNewMenu,
  styMenuListContainer,
  styMenuListItem,
  styMenuWebVersion,
  styTextMenuItem,
} from './style';

const MenuList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    eventClickLogout,
    eventClickReferralPage,
    eventClickReferralBonusHistory,
    eventClickHelpCenter,
  } = useEventTracker();

  const logout = useCallback(() => {
    eventClickLogout();
    const payload = {
      fcm_token: Cookies.get('notification_token'),
    };
    dispatch(onDoLogout(payload));
  });

  const { mtActive, mtInactive } = useContext(AuthContext);

  const [menuContents] = useState([
    {
      text: (
        <>
          Realized Profit/Loss <span className={styLabelNewMenu}>Baru</span>
        </>
      ),
      name: 'pnl',
      icon: <IconPnL />,
      onClick: () => {
        navigate('/pnl');
      },
    },
    {
      text: 'Margin Trading',
      name: 'marginTrading',
      icon: <IconMarginTrading />,
      onClick: () => {
        if (mtActive) {
          navigate('/margin-trading');
        } else if (mtInactive) {
          navigate('/margin-trading-onboarding');
        } else {
          navigate('/margin-trading-status');
        }
      },
      isSVG: true,
    },
    {
      text: 'Ajak Teman ',
      name: 'referral',
      icon: <IconAjakTeman />,
      onClick: () => {
        navigate('/referral');
        eventClickReferralPage();
      },
    },
    {
      text: 'Bonus',
      name: 'bonus',
      icon: <IconBonus />,
      onClick: () => {
        navigate('/referral/check-reward');
        eventClickReferralBonusHistory();
      },
    },
    {
      text: (
        <>
          Keamanan Akun <span className={styLabelNewMenu}>Baru</span>
        </>
      ),
      name: 'trusted-device',
      icon: <IconKeamananAkun />,
      onClick: () => navigate('/trusted-device'),
    },
    {
      text: 'Kalkulator',
      name: 'calcualtor',
      icon: <IconKalkulator />,
      onClick: () => navigate('/simulator'),
    },
    {
      text: 'Belajar',
      name: 'learn',
      icon: <IconBelajar />,
      onClick: () => window.open('https://ajaib.co.id/belajar/', '_blank'),
    },
    {
      text: 'Kamus',
      name: 'glossary',
      icon: <IconKamus />,
      onClick: () => window.open('/glossary', '_self'),
    },
    {
      text: 'Bantuan Ajaib',
      name: 'help',
      icon: <IconBantuanAjaib />,
      onClick: () => {
        eventClickHelpCenter();
        navigate('/faq');
      },
    },
    {
      text: 'Versi Aplikasi',
      name: 'version',
      desc: WEB_VERSION,
      icon: <IconKalkulator />,
    },
    {
      text: 'Keluar',
      name: 'logout',
      icon: <IconKeluar />,
      onClick: () => {
        logout();
      },
    },
  ]);

  return (
    <div className={styMenuListContainer}>
      {menuContents.map((menu) => (
        <div key={menu.name} className={styMenuListItem} onClick={menu.onClick}>
          <div>{menu.icon}</div>
          <div className={styTextMenuItem}>{menu.text}</div>
          {menu.desc && <span className={styMenuWebVersion}>{menu.desc}</span>}
        </div>
      ))}
    </div>
  );
};

export default MenuList;
